<template>
  <div class="yugao-container">
    <custom-router-link :item="info" class="yugao-link" :to="{name: 'HomeDetails', params: {id: info.id}}" target="_blank">
      <div class="yugao-image">
        <el-image :src="projectFileUrl + info.image" fit="cover" v-if="info.image"></el-image>
        <el-image :src="require('@/assets/images/img3.png')" fit="cover" v-else></el-image>
      </div>
      <div class="yugao-details">
        <div class="yugao-title">{{info.name}}</div>
        <div class="yugao-summary" v-html="info.summary">
        </div>
      </div>
    </custom-router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {
    info: {
      type: Object,
      default: () => { }
    }
  },
  components: {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.yugao-container {
  width: 100%;
  .yugao-link {
    display: flex;
    flex-direction: column;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.08);
    .yugao-image {
      width: 100%;
      height: 506px;
      .el-image {
        width: 100%;
        height: 100%;
      }
    }
    .yugao-details {
      width: 100%;
      padding: 20px;
      .yugao-title {
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        height: 56px;
        margin-bottom: 10px;
        color: #212529;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
      .yugao-summary {
        font-size: 15px;
        color: #6c757d;
        white-space: pre-wrap; // 此活动预告模块有时间地点展示，需加此属性
        height: 40px;
        overflow: hidden;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .yugao-container {
    .yugao-link {
      box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.04);
      .yugao-image {
        width: 100%;
        height: auto;
        aspect-ratio: 3/4;
        overflow: hidden;
      }
      .yugao-details {
        padding: 14px;
        .yugao-title {
          font-size: 18px;
          line-height: 24px;
          height: 48px;
          margin-bottom: 6px;
        }
        .yugao-summary {
          font-size: 13px;
          line-height: 20px;
        }
      }
    }
  }
}
</style>